module.exports = __webpack_public_path__ + "img/img3.604e114e.jpg";